<template>
  <v-container id="reserve-reception-page">
    <!--예약 접수 beta-->
    <div class="page-title">예약 접수</div>
    <v-row>
      <v-col cols="6">
        <customer-info
            :customerData.sync="input.customerData"
            :searchCustomerInfo="input.searchCustomerInfo"
            :voucherInfoList.sync="input.couponInfoList"
        />
      </v-col>
      <v-col cols="6">
        <reservation-info
            :reservationData.sync = "input.reservationData"
        />
      </v-col>
    </v-row>

    <search-location
        :customerData.sync="input.customerData"
        :reservationData.sync="input.reservationData"
        :reservationRouteData.sync="input.reservationRouteData"
        :locationData.sync="input.locationData"
        :fare-info="fareInfo"
        ref="searchLocation"
        class="search-location-container"
    />

    <v-card justify="start" class="mx-1 selectReservationType">
      <v-row justify="start" align="start">
        <v-tooltip left>
          <template #activator="{ on }">
            <v-icon class="mr-2" v-on="on">mdi-information-outline</v-icon>
          </template>
          <div style="width:200px;">
            <span class="tooltip__custom-chip">배차대기</span> 는 담당 차량이 배정되지 않은 상태입니다. 배차 요청을 통해 담당차량을 배정할 수 있습니다.
          </div>
        </v-tooltip>
        <c-btn class="mr-3" color="black" outlined @click="checkOverlappedReservation('waiting')" style="height: 45px; background-color:white;">배차대기</c-btn>
        <c-btn class="mr-3" color="blue" @click="checkOverlappedReservation('auto')" style="height: 45px">자동배차</c-btn>
        <c-btn color="blue" outlined @click="checkOverlappedReservation('manual')" style="background-color: white; opacity: 1; height: 45px">수동배차</c-btn>
      </v-row>
    </v-card>

    <!-- 예약 중복 탑승자 존재시 confirm Dialog -->
    <v-dialog v-model="input.overlappedReservationCheckDlg" width="400">
      <c-card class="white">
        <div class="py-5 text-center">
          <span class="blue--text font-weight-bold">{{ input.overlappedReserv.count }}</span>명이 동일한 시간대에 예약이 있습니다.<br>
          예약을 추가하시겠습니까?
          <div class="py-1" style="color:#BEBEBE;">{{ input.overlappedReserv.nameList }}</div>
        </div>
        <v-row justify="center" class="mb-4 ml-2">
          <c-btn class="mr-3" outlined color="grey" @click="closeOverlappedReservationCheckDlg">취소</c-btn>
          <c-btn class="mr-5" color="blue" @click="reqAddReservation">확인</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

    <!-- 예약 내용 확인 Dialog -->
    <v-dialog v-model="input.reservationCheckDlg" persistent max-width="1800px">
      <c-card class="white">
        <reservation-check
            :reservationCheckData="input.reservationCheckData"
            :reservationType.sync="input.reservationType"
        />
        <v-divider class="mb-3 mt-3"></v-divider>
        <v-row justify="center" class="mb-4">
          <c-btn class="mr-3" outlined color="grey" @click="goToInit()">처음으로</c-btn>
          <c-btn class="mr-5" color="blue" @click="onReserve">배차 요청</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

    <v-dialog
        v-model="input.autoDialogOpen"
        hide-overlay
        persistent
        width="300">
      <c-card class="blue">
        <v-card-text>
          <div class="py-6 text-center white--text">
            자동 배차 중입니다.
          </div>
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
              height="10">
          </v-progress-linear>
        </v-card-text>
      </c-card>
    </v-dialog>

    <manual-reserve-dialog
        :open.sync="input.manualDialogOpen"
        :reservationCheckData.sync="input.reservationCheckData"
        :reservationFlag.sync="input.manualReservationFlag"
        @initData="initData"
    />

    <time-recommend-dialog
        :open.sync="timeRecoDialogFlag"
        :reservation-id="autoReservationId"
        :fail-time="failTime"
        :available-time-list="availableTimeList"
        @reqAutoReservation="reqAutoReservation"
        @cancelAutoReservation="cancelAutoReservation"
    />

    <!-- 자동 배차 실패 팝업 -->
    <v-dialog v-model="autoFailDlg" width="400">
      <c-card class="white">
        <div class="pt-5 pb-3 text-center">자동 배차 가능한 차량이 없습니다.<br>수동 배차하시겠습니까?</div>
        <v-col cols="12">
          <c-btn block large color="blue" @click="setManualReserve">예</c-btn>
        </v-col>
        <v-col cols="12">
          <c-btn block large color="black" @click="setInit">아니오 (배차 대기)</c-btn>
        </v-col>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import CustomerInfo from './CustomerInfo2Beta';
  import ReservationInfo from './ReservationInfoBeta';
  // import SearchLocation from './SearchLocationBeta';
  import SearchLocation from './SearchLocationQuick.vue';
  import ReservationCheck from './ReservationCheck';
  import ManualReserveDialog from './ManualReserveDialogBeta';
  import TimeRecommendDialog from "@/views/CallTaxi/Reserve/TimeRecommendDialog";

  export default {
    components: {
      TimeRecommendDialog,
      SearchLocation, CustomerInfo, ReservationInfo, ReservationCheck, ManualReserveDialog},
    data() {
      return {
        fareInfo : {
          fareType: '',
          fareDetail: '',
        },
        input: {
          e1: 1,
          steps: 4,
          customerData: [],
          reservationData: null,
          locationData: null,
          reservationCheckData: null,
          reservationType: 'auto',
          overlappedReservationCheckDlg: false,
          reservationCheckDlg : false,
          autoDialogOpen: false,
          manualDialogOpen: false,
          manualReservationFlag: null,
          reservationUpdate : false,
          customerObject : {},
          originReservations: null,
          selectedDriverList: [],
          searchCustomerInfo: null,
          overlappedReserv: {
              isOverlapped: false,
              count: 0,
              nameList: [],
          },
          couponInfoList: [],
        },
        default: {
          e1: 1,
          steps: 4,
          reservationType: 'auto',
        },

        timeRecoDialogFlag: false,
        autoReservationId: '',
        autoReservationFlag: false,
        availableTimeList: [],
        failTime: '',
        autoFailDlg: false,
      }
    },
    mounted() {
      this.$event.$on('updateSelectedDriverList', (data) => {
        this.input.selectedDriverList = data;
      });

      const {path, params: {phoneNo, reservationId, canceledReservationId}, query: {n, p}} = this.$route;
      if (n || p) {
        const decP = p ? atob(p).trim() : '';
        const decN = n ? decodeURI(n).trim() : '';
        this.input.searchCustomerInfo = decP + '|' + decN;
      } else if (reservationId) {
        this.reqGetReservationInfo(reservationId, false);
      } else if(canceledReservationId) {
        this.reqGetReservationInfo(canceledReservationId, true);
      }

      if(Object.keys(this.$route.params).length > 0) {
        this.getCouponInfoListData();
      }
    },
    watch : {
      'input.manualReservationFlag' (newVal) {
        if (newVal) {
          this.$router.push(`/reservation/${this.input.reservationCheckData.reservationList[0].reservationId}`);
        }
      }
    },
    methods: {
      async checkOverlappedReservation(type) {
        const enableReservationResult = await this.$api.checkEnableReservation(this.$route.params.reservationId);
        if (!enableReservationResult.data) {
          this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "이용중 상태의 예약정보는 변경할 수 없습니다.",
              info: true
            });
          return;
        }

        this.input.reservationType = type;
        const customerData = this.input.customerData;
        const reservationData = this.input.reservationData;
        const locationData = this.input.locationData;
        const reservationRouteData = this.input.reservationRouteData;

        let res = [];
        let reqData = await this.makeReqReservationData(customerData, reservationData, reservationRouteData, locationData);
        if(reqData!=null){
          res = await this.$api.overlappedReserveData(reqData);
          this.overlappedReservationData = res.data;

          if(this.overlappedReservationData.isOverlapped) {
            this.input.overlappedReserv.isOverlapped = this.overlappedReservationData.isOverlapped;
            this.input.overlappedReserv.count = this.overlappedReservationData.count;
            this.input.overlappedReserv.nameList = this.overlappedReservationData.nameList.join();
            this.input.overlappedReservationCheckDlg = true;
          } else{
            await this.reqAddReservation();
          }
        }
      },
      async reqAddReservation() {
        try {
          const customerData = this.input.customerData;
          const reservationData = this.input.reservationData;
          const locationData = this.input.locationData;
          const reservationRouteData = this.input.reservationRouteData;

          let centerId = this.$store.state.centerInfo.centerId;

          if(!centerId) {
            this.$store.commit('snackbar', {msg: '로그인정보가 만료되었습니다.'})
            await this.$router.push('/');
          }

          if(!locationData.fareType) {
            const {data:fareData} =  await this.$api.getCenterInfoById(centerId);
            locationData.fareType = fareData.fareType.configValue;
          }
          let res = [];
          let reqData = await this.makeReqReservationData(customerData, reservationData, reservationRouteData, locationData);

          if (!!reqData) {
            //예약 변경
            if (this.input.reservationUpdate) {
              const orgReservationList = this.input.originReservations.reservationList;
              let updateResData = {
                ...reqData,
                reservationId : orgReservationList[0].reservationId
              };
              res = await this.$api.updateReservationWithPassengers(updateResData);
              //await this.$api.addCanceledReservation(reqData);
            } else {
              res = await this.$api.addReservationWithPassengers(reqData);
            }

            if (res.data && (res.data.passengerList.length > 0 && res.data.reservationList.length > 0)) {
              this.input.reservationCheckData = res.data;
              this.input.e1 += 1;
              await this.onReserve();
              this.input.overlappedReservationCheckDlg = false;
            } else {
              this.$store.commit('snackbar', {msg: '예약접수에 실패하였습니다. 잠시후 다시 시도해 주세요.'});
            }
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddReservation', msg: err.message ? err.message : '문제가 발생하였습니다. 잠시후 다시 시도해주세요.'});
        }
      },
      async makeReqReservationData(customerData, reservationData, reservationRouteData, locationData) {
        try {
          if (customerData.length === 0) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '회원 이름을 입력해주세요.'});
            return null;
          }

          // 예약 상세 정보 입력에서 일자 선택 시, 1. 잘못된 값을 입력했을 때(비어있는 필드가 있을 때)
          if (!this.reservationTimeCheck()) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '출발 일시를 올바르게 입력해주세요.'});
            return null;
          }

          // 센터정보에서 예약 가능한 시간이 아닐 때
          const centerOperTimeInfo = await this.getCenterOperTimeInfo();
          if (!this.checkEnableDriveTime(centerOperTimeInfo)) {
            const weekdayString = this.$func.getWeekdayString(centerOperTimeInfo.dayWeek);
            this.$store.commit('alert', {
              open: true, 
              title: '차량 운행 시간이 아닙니다.',
              msg: `${weekdayString} 차량 운행 시간은 ${centerOperTimeInfo.startDrive} ~ ${centerOperTimeInfo.endDrive} 입니다.`,
            });

            return null;
          }

          // stepper에서 도착지 검색 후 text를 지운경우, 출발지 or 도착지를 입력하고 검색하지 않은 경우 snackbar show
          if ( reservationRouteData.length === 0 ) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '출발지 / 도착지 검색을 완료해주세요.'});
            return null;
          }
          if(!(reservationRouteData[0].lat && reservationRouteData[0].lng))  {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '출발지 / 도착지 검색을 완료해주세요.'});
            return null;
          }

          if(!(reservationRouteData[1].lat && reservationRouteData[1].lng) ) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '출발지 / 도착지 검색을 완료해주세요.'});
            return null;
          }

          //차량옵션이 없을때
          if(reservationData.selectedVehicleOption.length === 0) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '차량 옵션유무를 선택해 주세요.'});
            return null;
          }


          const serviceTime = reservationData.selectedServiceTime === -1 ? parseInt(reservationData.selectedServiceInput) : reservationData.selectedServiceTime;
          const driveTime = this.input.locationData.driveTime;
          const startTime = this.$moment(reservationData.selectedDate + ' ' + reservationData.selectedTime).format('YYYY-MM-DD HH:mm:ss');
          const arriveTime = this.$moment(startTime).add(driveTime, 'ms').format('YYYY-MM-DD HH:mm:ss');
          const endTime = this.$moment(arriveTime).add(serviceTime, 'm').format('YYYY-MM-DD HH:mm:ss');

          let passengerReq = [], couponReq = [];
          customerData.forEach( obj => {

            let luggage = obj.luggage;
            if (luggage.indexOf(-1) > -1) {
              let idx = luggage.indexOf(-1);
              luggage.splice(idx, 1, obj.selectedLuggageInput)
            }

            passengerReq.push({
              customerId : obj.id,
              passengerType : obj.type,
              usages : obj.usages === -1 ? obj.selectedUseInput : obj.usages,
              luggage : luggage.join(),
            });

            if(obj.couponList.length) {
              for(let i=0;i<obj.couponList.length;i++) {
                couponReq.push({
                  customerId: obj.id,
                  couponId: obj.couponList[i].id,
                })
              }
            }
          })

          let vehicleOptionValue = '';
          if(reservationData.selectAllVehicleOption) {
            vehicleOptionValue = 'c_all';
          } else if(reservationData.selectedVehicleOption) {
              vehicleOptionValue = reservationData.selectedVehicleOption.join();
          }

          // 승하차 인원 값 강제 입력
          if (reservationRouteData.length > 1) {
            reservationRouteData[0].onCnt = customerData.length;
            reservationRouteData[1].offCnt = customerData.length;
          }

          const reqData =  {
            passengerList : passengerReq,
            reservationRouteList : reservationRouteData,
            couponInfoList: couponReq,

            vehicleCnt: reservationData.selectedCarCnt,
            vehicleType: reservationData.selectedCarTypeList.join(),
            vehicleOption: vehicleOptionValue,

            serviceTime: serviceTime,
            customerComment: reservationData.serviceComment ? reservationData.serviceComment : '',
            startTime: startTime,

            arriveTime: arriveTime,
            endTime: endTime,
            driveTime: driveTime,
            suburban: locationData.suburban === 'downTown' ? '0suburban' : '1suburban', // TODO: 추후 삭제대상
            fareType: locationData.fareType,
            fareDetail: locationData.fareDetail,
            expectedTotalDistance: locationData.driveDistance,
          };
          return reqData;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddReservation', msg: '문제가 발생하였습니다. 잠시후 다시 시도해주세요.'});
        }
      },
      reservationTimeCheck() {
        let reserveTime = this.input.reservationData.selectedTime.split(":");
        const hour = reserveTime[0];
        const minute = reserveTime[1];

        return (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59);
      },
      async getCenterOperTimeInfo() {
        const res = await this.$api.getCenterOperTime(this.$store.state.centerInfo.centerId);
        const selectedWeekday = this.$func.stringToDate(this.input.reservationData.selectedDate).weekday();

        const centerOperTimeInfo = res.data.find(centerOperTime => {
          if (!centerOperTime)
            return false;

          return (centerOperTime.dayWeek === selectedWeekday 
                && centerOperTime.operation === 'Enable');
        })

        return centerOperTimeInfo;
      },
      checkEnableDriveTime(centerOperTimeInfo) {
        if (!centerOperTimeInfo) {
          return false;
        }

        const [hour, minute] = this.input.reservationData.selectedTime.split(":");
        const [startDriveHour, startDriveMinute] = centerOperTimeInfo.startDrive.split(':');
        const [endDriveHour, endDriveMinute] = centerOperTimeInfo.endDrive.split(':');

        return (hour > startDriveHour || (hour === startDriveHour && minute >= startDriveMinute))
          && (hour < endDriveHour || (hour === endDriveHour && minute <= endDriveMinute));
      },
      onReserve() {
        if (this.input.reservationType === 'auto') {
          const resvData = this.input.reservationCheckData.reservationList[0];
          this.reqAutoReservation( resvData.reservationId, resvData.startTime);
        } else if (this.input.reservationType === 'manual') {
          this.input.manualDialogOpen = true;
        } else if (this.input.reservationType === 'waiting') {
          this.$store.commit('snackbar', {
            color: 'blue',
            msg: '예약 정보가 배차대기 상태로 저장됩니다. 추후 예약 내역에서 배차를 진행해주세요.'
          });
          this.initData();
        }
      },
      async reqGetReservationInfo(reservationId, isCanceled) {
        try {
          this.input.reservationUpdate = true;
          const res = !!isCanceled ? await this.$api.getCanceledReservationWithPassengers(reservationId)
              :  await this.$api.getReservationWithPassengers(reservationId);
          if (res.data.length === 0) {
            this.input.reservationUpdate = false;
            this.$store.commit('snackbar', {timeout: 2000, message: '예약정보가 없습니다.'});
            return;
          }

          // 같은 reservationId를 같는 모든 예약 리스트
          this.input.originReservations = res.data;

          const passengerList = res.data.passengerList;
          const reservationList = res.data.reservationList[0];

          if (passengerList[0].customerId !== null) {
            this.input.customerObject = passengerList[0].customer;
          }

          let idx = 1;
          passengerList.forEach( passenger => {

            let selectedUseInput = '';
            let usages = 0;
            if (passenger.usages.length > 0) {
              let useList = this.$store.state.centerInfo.useList.split(',');
              if (useList.indexOf(passenger.usages) === -1) {
                selectedUseInput = passenger.usages;
                usages = -1;
              }
            }

            let luggage = [];
            let selectedLuggageInput = '';
            if (passenger.luggage.length > 0) {
              passenger.luggage.split(',').forEach(item => {
                let find = false;
                this.$store.state.luggageList.forEach(e => {
                  if (e.value === item){
                    find = true;
                  }
                });

                if (find === true) {
                  luggage.push(item);
                } else {
                  luggage.push(-1);
                  selectedLuggageInput = item;
                }
              });
            }

            this.input.customerData.push({
              idx : passenger.passengerType === 'BOOKER' ? 0 : idx++ ,
              type : passenger.passengerType,
              name : passenger.customerName,
              mobileNo : passenger.customerNo,
              customerType : passenger.customerType,
              mobilityWeakInfo : passenger.mobilityWeakInfo,
              usages : usages === -1 ? usages : passenger.usages,
              selectedUseInput : usages === -1 ? selectedUseInput : '',
              luggage : luggage,
              selectedLuggageInput : selectedLuggageInput,
              id : passenger.customerId,
              passengerId: passenger.passengerId,
              couponList: [],
            });
          });
          this.input.customerData.sort(function(a,b){
              return a.idx - b.idx;
          });

          this.input.reservationData = {
            selectedDate: this.$func.dateToString(reservationList.startTime), //moment().format('YYYY-MM-DD'),
            selectedTime: this.$moment(reservationList.startTime).format('HH:mm'), //'00:00',
            selectedCustomerCnt: reservationList.customerCnt,
            selectedCustomerCntInput: '',
            selectedCarCnt: reservationList.vehicleCnt,
            selectedCarTypeList: reservationList.vehicleType.split(','),
            selectedServiceTime: reservationList.serviceTime,
            selectedServiceInput: '',
            selectedVehicleOption : reservationList.vehicleOption ? reservationList.vehicleOption.split(',') : [],
            serviceComment: reservationList.customerComment,
            routePackage: reservationList.routePackage
          };

          this.input.locationData = {
            driveTime: reservationList.driveTime, //ms
            suburban: reservationList.suburban,
            reservationRouteList: reservationList.reservationRouteList,
          };

          this.fareInfo = {
            fareType: reservationList.fareType,
            fareDetail: reservationList.fareDetail,
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetReservationInfo'});
        }
      },
      async reqAutoReservation(rId, startTime) {
        this.input.autoDialogOpen = true; //로딩바

        let reqData = {
          reservationId: rId,
          startTime: startTime,
          centerId: this.$store.state.centerInfo.centerId
        };

        try {
          const { data } = await this.$api.autoReservation(reqData);
          const { isAssignSuccess, reservableList } = data;

          // 자동배차 실패 인 경우
          if(!isAssignSuccess) {
            // 가능한 시간이 없을 경우
            if (reservableList.length < 1) {
              this.autoFailDlg = true;
              this.input.autoDialogOpen = false;
              return;
            }

            // 가능한 시간 팝업
            this.input.autoDialogOpen = false;
            this.autoReservationId = rId;
            this.failTime = startTime;
            this.availableTimeList = reservableList.map(item => {
              let newItem = {};
              newItem.text = this.$moment(item.date).format('HH:mm');
              newItem.value = item.date;
              return newItem;
            });

            this.timeRecoDialogFlag = true;
          } else {
            this.input.autoDialogOpen = false;
            this.timeRecoDialogFlag = false;
            this.$store.commit('snackbar', {color: 'blue', timeout: 2000, msg: '예약이 완료되었습니다.'});

            await this.$router.push(`/reservation/${rId}`);
          }
        } catch (err) {
          // 네트워크 에러일 때
          this.input.autoDialogOpen = false;
          this.$store.commit('alert',
              {
                err, where: 'reqAutoReservation',
                open: true, persistent: true, msg: "자동배차에 실패했습니다.",
                callBack: () => {
                  this.$router.push(`/reservation/${rId}`);
                }
              });
        }
      },
      cancelAutoReservation(rId) {
        this.$router.push(`/reservation/${rId}`);
      },
      nextStep(n) {
        switch (n) {
          case 1:
            const customerData = this.customerData;
            if (!customerData || !this.validate(customerData.mobileNo) || !this.validate(customerData.name)) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
              return;
            }

            if (!customerData.id) customerData.id = null;
            break;

          case 2:
            const reservationData = this.reservationData;
            const startTime = this.$moment(reservationData.selectedDate + ' ' + reservationData.selectedTime).format('YYYY-MM-DD HH:mm:ss');
            if (startTime < this.$func.curDateTimeString) {
              this.$store.commit('snackbar', {where: 'reqAddReservation', msg: '과거 시간은 예약이 불가능합니다. 시간을 다시 설정해주세요.'});
              return;
            }

            if (!reservationData
                || (reservationData.selectedCustomerCnt === -1 && !this.validate(reservationData.selectedCustomerCntInput))
                || (reservationData.selectedServiceTime === -1 && !this.validate(reservationData.selectedServiceInput))
                || (reservationData.selectedUse === -1 && !this.validate(reservationData.selectedUseInput))
                || (!reservationData.selectedCarTypeList || reservationData.selectedCarTypeList.length < 1)
            ) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
              return;
            }

            // 기타 인원수 입력시 5명 이상만 입력 가능하도록
            if (reservationData.selectedCustomerCnt === -1 && reservationData.selectedCustomerCntInput < 5) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '입력 값을 확인해주세요.'});
              return;
            }

            break;

          case 3:
            const locationData = this.locationData;
            if (!locationData || !this.validate(locationData.departure) || !this.validate(locationData.destination)) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
              return;
            }
            break;

          case 4:
            break;
        }

        if (n === this.input.steps) {
          this.input.e1 = 1
        } else {
          this.input.e1 = n + 1
        }
      },
      initData() {
        this.input = this.$func.initObjectData(this.input, this.default);
        this.$refs.searchLocation.clearData();
      },
      goToInit() {
        // 데이터 초기화
        this.input.reservationCheckDlg = false;
        this.initData();
        //window.location.href = '/ReserveReception';
      },
      closeOverlappedReservationCheckDlg() {
        this.input.overlappedReservationCheckDlg = false;
        this.input.overlappedReserv.isOverlapped = '';
        this.input.overlappedReserv.count = '';
        this.input.overlappedReserv.nameList = '';
      },
      setManualReserve() {
        this.autoFailDlg = false;
        this.input.manualDialogOpen = true;
      },
      setInit() {
        this.autoFailDlg = false;
        this.initData();
      },
      async getCouponInfoListData() {
        //passenger 별 사용한 coupon info 가져오기
        let id = '', params = this.$route.params;
        //예약 내역 상세일 경우 parameter 내 reservationId 사용, 예약 접수 확인 다이얼로그일 경우 reservationData 내 reservationId 사용
        if(params.reservationId) id = params.reservationId;
        else if(this.reservationData.reservationList[0].reservationId) id = this.reservationData.reservationList[0].reservationId;
        if(id) {
          const res = await this.$api.getUsedCoupons(id);
          this.input.couponInfoList = res.data;
        }
      },
    }
  }

</script>
<style lang="scss" scoped>
  .rsv-stepper {
    background-color: rgba(0, 0, 0, 0) !important;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0), 0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0) !important;
  }

  .rsv-stepper__content {
  }

  .rsv-stepper__header {
    background-color: white;
  }

  .search-location-container {
    margin-bottom: 50px;
  }

  .selectReservationType {
    position: fixed;
    padding: 15px 20px;
    bottom: 0;
    width: 100%;
    background-color: #f7f7f7;
    box-shadow: none;
  }

  .selectReservationType .v-btn-toggle > .v-btn.v-btn {
    border-radius: inherit !important;
  }
  .selectReservationType .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
    border-left-width: 1px !important;
    border-color: #2196F3 !important;
    border-radius: inherit !important;
  }
  .tooltip__custom-chip {
    background-color: #ed3843;
    color: #fff;
    border-radius: 15px;
    padding: 0 5px;
  }
</style>
